import type { SliderModal } from '@cian/frontend-newbuilding-promo-modal-widget';
import loadable from '@loadable/component';
import { LOADABLE_NO_SSR } from 'shared/utils/loadable';
import type * as React from 'react';

export type TSliderModalProps = React.ComponentProps<typeof SliderModal>;

/* istanbul ignore next */
export const SliderModalLoadable = loadable(() => import('@cian/frontend-newbuilding-promo-modal-widget'), {
  resolveComponent: ({ SliderModal }) => SliderModal,
  ...LOADABLE_NO_SSR,
});
